import type { RefObject } from 'react';
import { fadeTo } from 'util/animation/fade/fade';

interface DraggableFilterButtonsRefs {
  elementRef: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: DraggableFilterButtonsRefs,
): void {
  timeline.fromTo(elementRef.current, {}, {});
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: DraggableFilterButtonsRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement));
}

export function hide(
  refs: {
    elementRef?: RefObject<HTMLDivElement | null>;
  },
  hide: boolean = false,
): void {
  if (refs.elementRef?.current) {
    fadeTo(refs.elementRef.current, { to: hide ? 0 : 1 });
  }
}
